import { render, staticRenderFns } from "./CreateClaimLink.vue?vue&type=template&id=f0c820d6"
import script from "./CreateClaimLink.vue?vue&type=script&lang=js"
export * from "./CreateClaimLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports